<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <PageHeader :title="title" :items="items"/>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 150px">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
              <span v-for="(err, index) in validation_errors" :key="index">{{ err[0] }} <br/></span>
            </div>

            <form action="" enctype="multipart/form-data" files="true" role="form">
              <div class="form-row">
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza <span class="c-required">*</span></label>
                  <select v-model="mouza_id" v-validate="'required'" @change="getLaCase(mouza_id)"
                          class="form-control form-control-sm" name="mouza_id" id="mouza_id">
                    <option selected :value="''">Select a mouza</option>
                    <option v-for="(mouza, index) in mouzas" v-bind:value="mouza.id" :key="index">{{ mouza.id }} :
                      {{ mouza.mouza_desc }}
                    </option>
                  </select>
                  <div class="invalid-feedback">Mouza is required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="plot_schedule_id">Plot No <span
                      class="c-required">*</span></label>
                  <select v-model="plot_schedule_id" v-validate="'required'" class="form-control form-control-sm"
                          name="plot_schedule_id" id="plot_schedule_id">
                    <option selected :value="''">Select a plot no.</option>
                    <option v-for="(plot, index) in filteredPlots" v-bind:value="plot.id" :key="index">{{
                        plot.plot_no
                      }}
                    </option>
                  </select>
                  <div class="invalid-feedback">Plot no. is required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="selectedAwardBooks">Award Book</label>
                  <multiselect ref="selectedAwardBooks" v-model="selectedAwardBooks" id="selectedAwardBooks" name="selectedAwardBooks" :multiple="true" :clear-on-select="false" :preserve-search="true" placeholder="Select award book" track-by="id" :preselect-first="true" :options="filteredAwardBooks" :custom-label="customAwardBooks"></multiselect>
                  <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('selectedAwardBooks')">Award book no. is required.</div>
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="ccl_no">CCL No/Cheque No <span
                      class="c-required">*</span></label>
                  <input type="text" v-model="ccl_no" v-validate="{ required: true }" id="ccl_no" name="ccl_no"
                         placeholder="CCL no." class="form-control form-control-sm"/>
                  <div class="invalid-feedback">CCL no is required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="land_type">Land Type <span
                      class="c-required">*</span></label>
                  <multiselect ref="land_types" v-model="add_land_types" v-validate="{ required: true }" id="land_type"
                               name="add_land_types" :multiple="true" :clear-on-select="false" :preserve-search="true"
                               placeholder="Select land type" track-by="id" :options="land_types"
                               :custom-label="customLandType"></multiselect>
                  <span class="text-danger" v-if="errors.first('add_land_types')"
                        style="margin-top: 0.25rem; font-size: 0.75rem;">Land type is required </span>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="amount">Amount <span class="c-required">*</span></label>
                  <input type="text" v-model="amount" v-validate="{ required: true, max: 15, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/ }" id="amount" name="amount" placeholder="Amount" class="form-control form-control-sm"/>
                  <div class="invalid-feedback">Amount is required</div>
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="cheque_date">Cheque Date <span class="c-required">*</span></label>
                  <datepicker v-model="cheque_date" v-validate="'required'" id="cheque_date" name="cheque_date" :format="customChequeDate" placeholder="Cheque Date"></datepicker>
                  <div class="text-danger" v-if="errors.has('cheque_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">Cheque date required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="total_land">Total Land <span class="c-required">*</span></label>
                  <input type="number" v-model="total_land" v-validate="{ required: true, max: 15, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/ }" id="total_land" name="total_land" placeholder="In decimal (Only number allowed)" class="form-control form-control-sm"/>
                  <div class="invalid-feedback">Please enter total land in number format and not greater then 15 digit
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="number_of_eps">Number of EPs <span class="c-required">*</span></label>
                  <input type="number" v-model="number_of_eps" v-validate="'required|numeric'" id="number_of_eps" name="number_of_eps" placeholder="Number of EPs" class="form-control form-control-sm"/>
                  <div class="invalid-feedback">Please enter total land is required</div>
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="total_land">Award Book No. <span class="c-required">*</span></label>
                  <!--              <input type="text" v-model="book_no" v-validate="'required'" style="background-color: #e9ecef"  id="book_no" name="book_no" placeholder="Award book no." class="form-control form-control-sm"/>-->
                  <input type="text" v-model="book_no" v-validate="'required'" id="book_no" name="book_no" placeholder="Award book no." class="form-control form-control-sm"/>
                  <div class="invalid-feedback">Award book no. is required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="book_sub_no">Award Book Sub Serial</label>
                  <input type="text" v-model="book_sub_no" id="book_sub_no" name="book_sub_no" placeholder="Award book sub serial no." class="form-control form-control-sm"/>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="la_case_id">La Case <span class="c-required">*</span></label>
                  <select v-model="la_case_id" v-validate="'required'" class="form-control form-control-sm" name="la_case_id" id="la_case_id">
                    <option selected :value="''">Select a la case</option>
                    <option v-for="(la_case, index) in la_cases" v-bind:value="la_case.id" :key="index">{{ la_case.id }} : {{ la_case.la_case_desc }}</option>
                  </select>
                  <div class="invalid-feedback">La case is required</div>
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="ccl_type_id">CCL Type <span class="c-required">*</span></label>
                  <select v-model="ccl_type_id" v-validate="'required'" class="form-control form-control-sm" name="ccl_type_id" id="ccl_type_id">
                    <option selected :value="''">Select a CCL type</option>
                    <option v-for="(ccl_type, index) in ccl_types" v-bind:value="ccl_type.id" :key="index">{{ ccl_type.id }} : {{ ccl_type.ccl_type_desc }}</option>
                  </select>
                  <div class="invalid-feedback">CCL type is required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="ccl_register_no">CCL Register No.</label>
                  <input type="text" v-model="ccl_register_no" v-validate="{ max: 3999 }"  id="ccl_register_no" name="ccl_register_no" placeholder="CCL register no." class="form-control form-control-sm"/>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="collection_date">Collection Date <span class="c-required">*</span></label>
                  <datepicker v-model="collection_date" v-validate="'required'" id="collection_date" name="collection_date" :format="customCollectionDate" placeholder="Collection Date"></datepicker>
                  <div class="text-danger" v-if="errors.has('collection_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">Collection date required</div>
                </div>
              </div>
              <div class="form-row mt-2">


                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="collected_by">Collected By <span class="c-required">*</span></label>
                  <input type="text" v-model="collected_by" v-validate="'required'" id="collected_by" name="collected_by" placeholder="Collected by...." class="form-control form-control-sm"/>
                  <div class="invalid-feedback">Collected by is required</div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <label class="col-form-label col-form-label-sm" for="file">Document <span style="font-weight: 100;">*Previous file <a :href="file" target="_blank">click here</a></span></label>
                  <input type="file" ref="file" id="file" name="file" @change="getFile()" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="form-control form-control-sm"/>
                  <div class="invalid-feedback">CCL document is required</div>
                </div>
              </div>
              <b-button class="form-control-sm mr-2 mt-3" size="sm" variant="warning" @click.prevent="update">Update</b-button>
              <b-button class="form-control-sm mt-3" size="sm" variant="danger" @click="$bvModal.hide('ccl-update-modal')">Cancel</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "CCL Update From SES",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, Datepicker, Multiselect},
  data() {
    return {
      title: "CCL Update From SES",
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'SES',
          active: true,
        },
      ],
      award_books: [],
      mouzas: [],
      plots: [],
      land_types: [],
      ccl_types: [],
      la_cases: [],
      award_book_id: '',
      ccl_no: '',
      add_land_types: [],
      selectedAwardBooks: [],
      amount: '',
      cheque_date: '',
      total_land: '',
      number_of_eps: '',
      file: '',
      book_no: '',
      book_sub_no: '',
      la_case_id: '',
      mouza_id: '',
      plot_schedule_id: '',
      ccl_type_id: '',
      id: '',
      ccl_register_no: '',
      collection_date: '',
      collected_by: '',
      validation_errors: {},
      show: false
    };
  },

  mounted() {
    this.getCodes();
    this.onUpdate();
  },

  methods: {
    getCodes() {
      http.get("api/ccl/cclCodes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.mouzas = data.mouzas;
          this.plots = data.plots;
          this.land_types = data.land_types;
          this.ccl_types = data.ccl_types;
          this.award_books = data.award_books;
        }
      });
    },
    customLandType(option) {
      return `${option.id}: ${option.land_type_desc}`;
    },
    customAwardBooks(option) {
      return `${option.id}: ${option.name}, Type :  ${option.award_book_type.award_book_type_desc}, Mouza :  ${option.mouza.mouza_desc}, Plot :  ${option.plot_schedule.plot_no}`;
    },
    customCollectionDate(date) {
      this.collection_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    customChequeDate(date) {
      this.cheque_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },

    getFile() {
      this.file = this.$refs.file.files[0];
      if (this.file.size > 10000000) {
        this.$bvToast.toast("File size not greater then 10 MB", {
          title: "Error",
          autoHideDelay: 5000,
          variant: "error"
        });
        this.file = "";
      }
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let formData = new FormData();

          formData.append('file', this.file);
          // formData.append('file', this.file ? this.file : null);
          formData.append("ccl_no", this.ccl_no);
          formData.append("mouza_id", this.mouza_id);
          formData.append("plot_schedule_id", this.plot_schedule_id);
          formData.append("ccl_type_id", this.ccl_type_id);
          formData.append("land_types", JSON.stringify(this.add_land_types));
          formData.append("award_books", JSON.stringify(this.selectedAwardBooks));
          formData.append("amount", this.amount);
          formData.append("cheque_date", this.cheque_date);
          formData.append("total_land", this.total_land);
          formData.append("number_of_eps", this.number_of_eps);
          formData.append("book_no", this.book_no);
          formData.append("book_sub_no", this.book_sub_no);
          formData.append("la_case_id", this.la_case_id);
          //formData.append("award_book_id", this.award_book_id);
          formData.append("ccl_register_no", this.ccl_register_no);
          formData.append("collection_date", this.collection_date);
          formData.append("collected_by", this.collected_by);

          http
              .post("api/ccl/update/" + this.id, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Content-type": "application/json"
                }
              })
              .then(response => {
                if (!response.error) {
                  this.$bvToast.toast("CCL saved successfully", {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  window.close();
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    async onUpdate() {
      this.resetForm();
      let id = this.$route.params.ccl_id;
      await http.get("api/ccl/edit/" + id).then(response => {
        this.ccl_no = response.data.ccl.ccl_no;
        this.mouza_id = response.data.ccl.mouza_id;
        this.ccl_type_id = response.data.ccl.ccl_type_id;
        this.plot_schedule_id = response.data.ccl.plot_schedule_id;
        this.add_land_types = response.data.ccl.land_types;
        this.amount = response.data.ccl.amount;
        this.cheque_date = response.data.ccl.cheque_date;
        this.total_land = response.data.ccl.total_land;
        this.number_of_eps = response.data.ccl.number_of_eps;
        this.book_no = response.data.ccl.book_no;
        this.book_sub_no = response.data.ccl.book_sub_no;
        this.la_case_id = response.data.ccl.la_case_id;
        this.id = response.data.ccl.id;
        this.award_book_id = response.data.ccl.award_book_id;
        this.file = response.data.ccl.document;
        this.add_ccl_types = response.data.ccl.ccl_types;
        this.ccl_register_no = response.data.ccl.ccl_register_no;
        this.collection_date = response.data.ccl.collection_date;
        this.collected_by = response.data.ccl.collected_by;
        this.getLaCase(response.data.ccl.mouza_id);
        this.getAwardBookInfo(response.data.ccl.award_book_id);

      });
    },
    getLaCase(mouza_id) {
      http.get("api/ccl/getLaCase/" + mouza_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.la_cases = data.la_cases;
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
    resetForm() {
      this.$validator.reset();
      this.ccl_no = "";
      this.mouza_id = "";
      this.plot_schedule_id = "";
      this.add_land_types = "";
      this.amount = "";
      this.cheque_date = "";
      this.total_land = "";
      this.number_of_eps = "";
      this.ccl_type_id = "";
      this.book_no = "";
      this.book_sub_no = "";
      this.file = "";
      this.ccl_register_no = "";
    },
    getAwardBookInfo(award_book_id) {
      if (award_book_id) {
        let award_book = this.award_books.find(v => v.id == award_book_id);
        this.book_no = award_book.book_no
        this.book_sub_no = award_book.sub_book_no
      }

    },
  },
  computed: {
    filteredPlots() {
      if (this.mouza_id === '') {
        return [];
      } else {
        const mouza_id = this.mouza_id;

        return this.plots.filter((plot) => plot.mouza_id === mouza_id)
      }
    },
    filteredAwardBooks() {
      if (this.mouza_id === '' && this.plot_schedule_id === '') {
        return [];
      } else {
        const mouza_id = this.mouza_id;
        const plot_schedule_id = this.plot_schedule_id;
        return this.award_books.filter((award_book) => award_book.mouza_id === mouza_id &&
            award_book.plot_schedule_id === plot_schedule_id)
      }
    }
  }
};
</script>
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
  -webkit-appearance: unset;
}

.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}

.multiselect__tags {
  border-color: #ced4da;
  border-radius: 3px;
  min-height: 31px;
  padding: 4px 25px 0px 10px;
  margin-bottom: 0;
}

.multiselect__tag {
  margin-bottom: 0px;
}

.multiselect__placeholder {
  margin-bottom: 0px;
}

.multiselect__select {
  height: 31px;
}

.custom-select {
  color: #6c757d !important;
}

.c-required {
  color: red;
}
</style>
